import { IpDialog, useAuth } from '@blockfin/blockfin-component';
import { NavFooter, NavHeader } from '@blockfin/blockfin-nav';
import { NoticeProvider, ThemeProvider } from '@blofin/blofin-ui';
import { useRouter } from 'next/router';
import { CSSProperties, FC, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import BlofinNative from 'sdk';
import getConfig from 'next/config';
import { getSavedFingerprintID } from 'utils/fingerprint';
import KycAlert from './KycAlert';
import { getUserKycLevel, isError } from 'services/activity';
import clsx from 'clsx';

const IndexLayout: FC<{
  children: ReactNode;
  colorType: number;
  footerColorType?: number;
  mainClassName?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
  mainStyle?: CSSProperties;
  hideSignUpAndLogIn?: boolean;
  isApp?: boolean;
  footerTheme?: 'light' | 'dark';
  isDemoTrading: 0 | 1 | 2;
  footerBgColor?: string;
  isSimpleFooter?: boolean;
}> = (props) => {
  const {
    children,
    colorType,
    footerColorType,
    hideHeader = false,
    hideFooter = false,
    mainClassName,
    mainStyle,
    hideSignUpAndLogIn = false,
    isApp = false,
    footerTheme = 'dark',
    isDemoTrading,
    footerBgColor = '',
    isSimpleFooter = true,
  } = props;
  const { locale, query, asPath } = useRouter();
  const { isLogin } = useAuth();
  const [kycLevel, setKycLevel] = useState<number>();
  const noShowKycAlertPages = useRef(['/', '/competition/league/search', '/wow2024/search']);

  const showKycAlert = useMemo(() => {
    if (kycLevel === undefined || isNaN(Number(kycLevel))) {
      return false;
    }
    return Number(kycLevel) < 1;
  }, [kycLevel]);

  const fetchKycLevel = useCallback(async () => {
    const res: any = await getUserKycLevel();
    if (!isError(res)) {
      setKycLevel(res.level_id);
    }
  }, []);

  useEffect(() => {
    if (isApp && !getSavedFingerprintID()) {
      BlofinNative.getRequestId('activity');
    }
  }, [isApp]);

  useEffect(() => {
    if (isLogin && !noShowKycAlertPages.current.includes(asPath || '/')) {
      fetchKycLevel();
    }
  }, [isLogin, asPath, fetchKycLevel]);

  // useEffect(() => {
  //   if (isDemoTrading && isLogin === false && (asPath || '/') !== '/') {
  //     window.location.href = generateRedirectUrl({ host: window.location.host, local: locale || 'en', path: asPath });
  //   }
  // }, [isDemoTrading, isLogin, locale, asPath, query]);

  const baseUrl = useMemo(() => {
    const { publicRuntimeConfig } = getConfig();
    return isDemoTrading === 2 ? publicRuntimeConfig.base.demoUrl : publicRuntimeConfig.base.baseUrl;
  }, [isDemoTrading]);

  return (
    <NoticeProvider>
      {!hideHeader && !isApp && (
        <NavHeader
          apiConfig={{ baseUrl }}
          locale={locale}
          showTheme={false}
          themeLock={true}
          hideSignUpAndLogIn={hideSignUpAndLogIn}
          theme={colorType === 1 ? 'light' : 'dark'}
        />
      )}
      {showKycAlert && <KycAlert isApp={isApp} />}
      <main
        className={clsx(
          mainClassName || '',
          'group/main mt-[-64px] data-[exclusive=true]:!mt-0 data-[is-app=true]:!mt-0 data-[show-kyc-alert=true]:mt-[-100px] md:data-[show-kyc-alert=true]:mt-[-112px]'
        )}
        style={mainStyle || {}}
        data-show-kyc-alert={showKycAlert}
        data-exclusive={['/'].includes(asPath)}
        data-is-app={isApp}
      >
        {children}
      </main>
      <ThemeProvider value={{ theme: 'light' }}>
        <IpDialog />
      </ThemeProvider>
      {!hideFooter && (
        // <Footer theme="dark" lang={locale as LanguagesType} />
        <NavFooter
          isSimple={isSimpleFooter}
          apiConfig={{ baseUrl }}
          theme={footerTheme}
          footerBgColor={isSimpleFooter ? `!pl-[24px] ${footerBgColor}` : footerBgColor}
        />
      )}
    </NoticeProvider>
  );
};

export default IndexLayout;
